
import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];

import { defineComponent, ref } from 'vue';
import {useStore} from "vuex";

import fintailapi from "../api";

export default defineComponent({
  name: "signin",
  components: {
    Navbar,
    ArgonInput,
    ArgonSwitch,
    ArgonButton,
  },
  data() {
    return {
      username: "",
      password: "",
      save: false,
      isLast: false,
      error:{ show:false, message: ""},
      store : useStore()
    }
  },
  async created() {
    // Configura interface
    this.store.state.hideConfigButton = true;
    this.store.state.showNavbar = false;
    this.store.state.showSidenav = false;
    this.store.state.showFooter = false;
    body.classList.remove("bg-gray-100");

    // 🔹 Verifica se há credenciais salvas
    const savedUserRaw = localStorage.getItem("user");
    if (savedUserRaw) {
      try {
        const savedUser = JSON.parse(savedUserRaw);
        this.username = savedUser.username;
        this.password = savedUser.password;

        localStorage.setItem("reOpen", "true");

        //Login automático
        if (this.username && this.password) {
          this.doLogin();
        }
      } catch (e) {
        console.warn("Erro ao ler dados salvos:", e);
      }
    }
  },
  beforeUnmount() {
    this.store.state.hideConfigButton = false;
    this.store.state.showNavbar = true;
    this.store.state.showSidenav = true;
    this.store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
   methods: {
    
    doLogin() {

  

        fintailapi
        .post('/auth/login', { "username": this.username, "password": this.password  })
        .then((response:any) => {

          if(response.data.role != "operador" && response.data.role != "master" && response.data.role != "portal"){

            this.error = { show:true,  message: "Usuário Não Permitido"}
            
            return
          }

          this.store.state.user.isAuthenticated = true;
           this.store.state.user.userRole = response.data.role;

          fintailapi.defaults.headers.common['Authorization'] = "Bearer "+ response.data.token;



          if (this.save) {
            localStorage.setItem(
              "user",
              JSON.stringify({
                username: this.username,
                password: this.password,
                refresh: response.data.refresh_token || null,
              })
            );
          }

          this.$router.push('/dashboard');

        })
        .catch((error:any) => {

          console.log(error.response)
     
          this.error = { show:true,  message: error.response.data.error}
            

        })

    }
   }
});
